import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';
import React from 'react';
import type { FC } from 'react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';
import { defineMessages, FormattedMessage } from 'react-intl';

import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay.ts';
import { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

export const i18n = defineMessages({
	followMutationErrorTitle: {
		id: 'profile.card.feed.follow.mutation.error.title',
		defaultMessage: 'We’re having trouble doing that',
		description:
			'Title of error flag shown when a user attempts to follow/unfollow a user but the action fails.',
	},
	followMutationErrorDescription: {
		id: 'profile.card.feed.follow.mutation.error.description',
		defaultMessage: 'Try following or unfollowing this user again ',
		description:
			'Body of error flag shown when a user attempts to unfollow/follow a user but the action fails. Shown below the error title',
	},
});

type FeedFollowErrorDisplayProps = {
	feedConfigError: ApolloErrorInterop | undefined;
	mutationError: ApolloErrorInterop | undefined;
	showErrorFlag?: boolean;
};

export const FeedFollowErrorDisplay: FC<FeedFollowErrorDisplayProps> = ({
	feedConfigError,
	mutationError,
	showErrorFlag,
}) => (
	<>
		{feedConfigError ? <ErrorDisplay error={feedConfigError} /> : null}
		{mutationError ? (
			<ErrorDisplay error={mutationError}>
				<Subscribe to={[FlagsStateContainer]}>
					{(flags: FlagsStateContainer) => {
						if (showErrorFlag) {
							void flags.showErrorFlag({
								title: <FormattedMessage {...i18n.followMutationErrorTitle} />,
								description: <FormattedMessage {...i18n.followMutationErrorDescription} />,
							});
						}
						return null;
					}}
				</Subscribe>
			</ErrorDisplay>
		) : null}
	</>
);
